/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { typedDependencies } from './dependenciesTyped.generated.js';
import { createRandomInt } from '../../factoriesAny.js';
export var randomIntDependencies = {
  typedDependencies,
  createRandomInt
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/lib/esm/entry/dependenciesAny/dependenciesRandomInt.generated.js
// module id = 1447
// module chunks = 2